/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

const headers = {
  isAuthRequired: true,
  "Content-Type": "application/json",
  "x-tenant-slug": "default",
};

export default {
  // params : { kind?: "VEHICLE" | "ITEM", q?, city?, in_stock?: "true" | "false", months?, sort? }
  getShopCatalog: (params) => {
    return axios.get(API_ENDPOINTS.GET_MPLUS_SHOP_CATALOG, { headers, params });
  },
  // Modèles M+ : la liste est dans data.data.data
  getProductCatalog: (params) => {
    return axios.get(API_ENDPOINTS.GET_PRODUCT_CATALOG, {
      headers,
      params: { program_code: "METUAA_MPLUS", is_active: true, page: 1, limit: 100, ...params },
    });
  },
  // Création / modification d'un modèle (admin). FormData si une photo est envoyée (champ product_image).
  createProduct: (data) => {
    const multipart = typeof FormData !== "undefined" && data instanceof FormData;
    return axios.post(API_ENDPOINTS.GET_PRODUCT_CATALOG, data, {
      headers: { ...headers, "Content-Type": multipart ? "multipart/form-data" : "application/json" },
    });
  },
  updateProduct: (id, data) => {
    const multipart = typeof FormData !== "undefined" && data instanceof FormData;
    return axios.patch(`${API_ENDPOINTS.GET_PRODUCT_CATALOG}/${id}`, data, {
      headers: { ...headers, "Content-Type": multipart ? "multipart/form-data" : "application/json" },
    });
  },
  // Emplacements : entrepôt, hubs, en circulation…
  getLocations: () => {
    return axios.get(API_ENDPOINTS.MPLUS_LOCATIONS, { headers });
  },
  // params : { status?, product_catalog_id?, location_id?, city?, page, limit }
  getStock: (params) => {
    return axios.get(API_ENDPOINTS.MPLUS_STOCK, { headers, params });
  },
  // Réception d'un véhicule acheté (statut RECEIVED, entrepôt central par défaut)
  receiveVehicle: (data) => {
    return axios.post(API_ENDPOINTS.MPLUS_STOCK, data, { headers });
  },
  getVehicle: (id) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_STOCK}/${id}`, { headers });
  },
  updateVehicle: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.MPLUS_STOCK}/${id}`, data, { headers });
  },
  // Contrôles avant vente : contrôle technique, carte grise, assurance, GPS
  updateVehicleDocuments: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.MPLUS_STOCK}/${id}/documents`, data, { headers });
  },
  getVehicleHistory: (id) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_STOCK}/${id}/history`, { headers });
  },
  // action : make-available | transfer | receive-transfer | quarantine | back-to-received | return | write-off
  runVehicleAction: (id, action, data = {}) => {
    return axios.post(`${API_ENDPOINTS.MPLUS_STOCK}/${id}/${action}`, data, { headers });
  },

  // --- Simulation et éligibilité (section 5) ---
  simulateSchedule: (params) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/simulate-schedule`, { headers, params });
  },
  // params : { product_catalog_id, number_of_repayments, quantity }
  getEligibility: (userId, params) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/eligibility/${userId}`, { headers, params });
  },
  getEligibilitySettings: () => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/settings/eligibility`, { headers });
  },
  // Seules les clés envoyées changent.
  updateEligibilitySettings: (data) => {
    return axios.put(`${API_ENDPOINTS.MPLUS_BASE}/settings/eligibility`, data, { headers });
  },

  // --- Dossiers M+ (section 6) ---
  getFinancings: (params) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/financings`, { headers, params });
  },
  createFinancing: (data) => {
    return axios.post(`${API_ENDPOINTS.MPLUS_BASE}/financings`, data, { headers });
  },
  getFinancing: (id) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/financings/${id}`, { headers });
  },
  // Brouillon : conditions (statut SUBMITTED) et livraison prévue (jusqu'à LOAN_APPROVED).
  updateFinancing: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.MPLUS_BASE}/financings/${id}`, data, { headers });
  },
  // action : setup-fineract | create-loan | approve-loan | reserve | release-asset | deliver | cancel | generate-contracts | pause
  runFinancingAction: (id, action, data = {}) => {
    return axios.post(`${API_ENDPOINTS.MPLUS_BASE}/financings/${id}/${action}`, data, { headers });
  },
  getFinancingSchedule: (id) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/financings/${id}/schedule`, { headers });
  },

  // --- Contrats et signatures (section 7) ---
  getFinancingContracts: (id) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/financings/${id}/contracts`, { headers });
  },
  getApplicationContracts: (leaseId) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/applications/${leaseId}/contracts`, { headers });
  },
  // Ouvrir le PDF enregistre la lecture (exigée avant la demande de code).
  downloadContract: (id, version) => {
    return axios.get(`${API_ENDPOINTS.GET_CONTRACTS}/${id}/download`, {
      headers,
      params: version ? { version } : undefined,
      responseType: "blob",
    });
  },
  requestContractSignature: (id) => {
    return axios.post(`${API_ENDPOINTS.GET_CONTRACTS}/${id}/request-signature`, {}, { headers });
  },
  signContract: (id, otp) => {
    return axios.post(`${API_ENDPOINTS.GET_CONTRACTS}/${id}/sign`, { otp, accept: true }, { headers });
  },
  getContractVersions: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_CONTRACTS}/${id}/versions`, { headers });
  },

  // --- Prélèvements LewooPay (section 9) ---
  getFinancingCollections: (id) => {
    return axios.get(`${API_ENDPOINTS.MPLUS_BASE}/financings/${id}/collections`, { headers });
  },
  // dry_run: true calcule sans prélever.
  runCollections: (data) => {
    return axios.post(`${API_ENDPOINTS.MPLUS_BASE}/collections/run`, data, { headers });
  },
};
